<div class="layout__main in">

  <div class="question-heading question-heading--quotes">
    <div class="question-heading__avatar">
      <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
    </div>
    <div class="question-heading__content">
      <h3 class="h4" [innerHtml]="header" ></h3>
    </div>
  </div>
  <div class="question question--quotes">
    @if (!subCategory) {
      <ul class="claim-categories claim-categories--product-type list-unstyled">
        @for (quote of getCategories(); track quote) {
          <li class="claim-categories--{{quote.header.substring(0, quote.header.indexOf('.')).toLowerCase()}}">
            <a href="javascript:;" (click)="setCategory(quote)" data-product="true" class="claim-categories__item">
              <div class="claim-categories__item-content">
                <h5>{{quote.header}}</h5>
                <p>{{quote.body}}.</p>
              </div>
              <div class="claim-categories__btn-select">
                <svg class="icon">
                  <use xlink:href="#right-small"></use>
                </svg>
              </div>
            </a>
          </li>
        }
      </ul>
    }
    @if (subCategory) {
      <ul class="claim-categories claim-categories--product-type list-unstyled">
        @for (quote of getSubCategory(); track quote) {
          <li class="claim-categories--{{category.header.substring(0, category.header.indexOf('.')).toLowerCase()}}">
            <a href="javascript:;" (click)="redirectToAcquisition(quote)" data-product="true" class="claim-categories__item">
              <div class="claim-categories__item-content">
                <h5>{{quote.header}}</h5>
                <p>{{quote.body}}.</p>
              </div>
              <div class="claim-categories__btn-select">
                <svg class="icon">
                  <use xlink:href="#right-small"></use>
                </svg>
              </div>
            </a>
          </li>
        }
      </ul>
    }
    @if (subCategory) {
      <div class="text-center mt-25">
        <a href="javascript:;" (click)="backToCategories()" class="button-control"><svg class="icon"><use xlink:href="#left-small"></use></svg><strong>Back</strong></a>
      </div>
    }
  </div>

</div>



<!-- <div class="layout__main in" >

<div class="question-heading question-heading--quotes">
  <div class="question-heading__avatar">
    <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
  </div>
  <div class="question-heading__content">
    <h3 class="h4" [innerHtml]="question.question_copy" [@slideOutLeftOnLeave]="true"  [@slideInRightOnEnter]="true" ></h3>
  </div>
</div>
<div class="question question--quotes">
  <ul *ngIf="question.question_id==0" [@slideOutLeftOnLeave]="true"  [@slideInRightOnEnter]="true" class="claim-categories claim-categories--product-type list-unstyled">
    <li class="claim-categories--personal">
      <a href="javascript:;" (click)="nextQuestion()" data-product="true" class="claim-categories__item">
        <div class="claim-categories__item-content">
          <h5>Personal Insurance for Everyone</h5>
          <p>Products designed to cover personal assets, from vehicles and homes to electronics and jewellery.</p>
        </div>
        <div class="claim-categories__btn-select">
          <svg class="icon">
            <use xlink:href="#right-small"></use>
          </svg>
        </div>
      </a>
    </li>
    <li class="claim-categories--personal">
      <a href="#" data-product="true" class="claim-categories__item">
        <div class="claim-categories__item-content">
          <h5>Personal Insurance for Golfers</h5>
          <p>Products designed for the avid golfer, covering your personal assets with golf specific extras to sweeten
          the deal.</p>
        </div>
        <div class="claim-categories__btn-select">
          <svg class="icon">
            <use xlink:href="#right-small"></use>
          </svg>
        </div>
      </a>
    </li>
  </ul>
  <ul *ngIf="question.question_id==1" [@slideOutLeftOnLeave]="true"  [@slideInRightOnEnter]="true" class="claim-categories claim-categories--product-type list-unstyled">
    <li class="claim-categories--personal">
      <a href="javascript:;" data-product="true" class="claim-categories__item">
        <div class="claim-categories__item-content">
          <h5>Personal Insurance for Everyone</h5>
          <p>Products designed to cover personal assets, from vehicles and homes to electronics and jewellery.</p>
        </div>
        <div class="claim-categories__btn-select">
          <svg class="icon">
            <use xlink:href="#right-small"></use>
          </svg>
        </div>
      </a>
    </li>

  </ul>
</div>

</div> -->

@if (map) {
  <div  class="form-group form-group--lg question question-{{question.group_type}}">
    <label>{{question.email_version}}</label>
    <div class="form-control__wrap has-clear has-marker">
      <input type="search" value="{{question.answer}}" placeholder="Start typing address" id="pac-input" autocomplete="off" class="form-control" data-place="" #search />
      <span class="form-control__marker">
        <svg class="icon"><use xlink:href="#location"></use></svg>
      </span>
      <a href="#" id="clear-address" class="form-control__clear"><svg class="icon"><use xlink:href="#close-circle-small"></use></svg></a>
    </div><br>
    <div class="spinner">
      <ng-lottie [options]="lottieOptions"></ng-lottie>
    </div>
    <google-map height="160px" width="100%" [zoom]="zoom" [center]="center" [hidden]="question.group_type!='details' || question.question_type_id!=3"
      [options]="options">
      <map-marker [position]="marker.position" [label]="marker.label" [title]="marker.title"
        [options]="marker.options">
      </map-marker>
    </google-map>
    <br><br>
  </div>
}

@if (question.question_type_id==2 || question.question_type_id==73|| question.question_type_id==74 || question.question_type_id==75) {
  <div
    class="form-group form-group--lg question question-{{question.group_type}}">
    <label>{{question.email_version}}</label>
    <input id="{{question.question_id}}" [(ngModel)]="question.answer" (blur)="saveAnswer()" type="text"
      value="{{question.answer}}" class="form-control answers" />
      <br><br>
    </div>
  }

  @if (question.question_type_id==4) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="custom-step">
        <div class="custom-step__control custom-step__control--dsc" (click)="setStep(-1, question)">
          <svg class="icon"><use xlink:href="#minus"></use></svg>
        </div>
        <input class="form-control currency" readonly value="{{question.answer}}"/>
        <div class="custom-step__control custom-step__control--asc" (click)="setStep(1, question)">
          <svg class="icon"><use xlink:href="#plus"></use></svg>
        </div>
      </div>
      <br><br>
    </div>
  }

  @if (question.question_type_id==7 && question.options.indexOf('Yes') >= 0 && question.question_id!=576) {
    <div class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="row row--sm">
        <div class="col-sm mt-15 mt-sm-0">
          <label class="custom-input custom-input--radio custom-input--pill">
            @if (question.answer.indexOf('Yes') >= 0) {
              <input type="radio" [attr.question-id]="question.question_id" [attr.data-answer-id]="question.cent_aq_answer_id"
                data-answer="Yes" (click)="checkRadio('Yes')" checked  name="radio-col-{{question.question_id}}[]" />
            }
            @if (question.answer.indexOf('No') >= 0) {
              <input type="radio" [attr.question-id]="question.question_id" [attr.data-answer-id]="question.cent_aq_answer_id"
                data-answer="Yes" (click)="checkRadio('Yes')"  name="radio-col-{{question.question_id}}[]" />
            }
            <span class="custom-input__indi"></span> <span class="custom-input__label">Yes</span>
          </label>
        </div>
        <div class="col-sm mt-15 mt-sm-0">
          <label class="custom-input custom-input--radio custom-input--pill">
            @if (question.answer.indexOf('No') >= 0) {
              <input type="radio" [attr.question-id]="question.question_id" data-answer="No"
                (click)="checkRadio('No')" checked name="radio-col-{{question.question_id}}[]">
            }
            @if (question.answer.indexOf('Yes') >= 0) {
              <input type="radio" [attr.question-id]="question.question_id" data-answer="No"
                (click)="checkRadio('No')" name="radio-col-{{question.question_id}}[]">
            }
            <span class="custom-input__indi"></span>
            <span class="custom-input__label">No</span>
          </label>
        </div>
      </div>
      <br><br>
    </div>
  }



  @if (question.question_type_id==7 && question.question_id==576) {
    <div class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
        <label class="custom-input custom-input--radio custom-input--pill">
          @if (option.answer==question.answer) {
            <input checked type="radio" (click)="checkRadio(option.answer)" [attr.data-answer]="option.answer" name="radio-{{question.question_id}}[]"/>
          }
          @if (option.answer!=question.answer) {
            <input type="radio" (click)="checkRadio(option.answer)" [attr.data-answer]="option.answer" name="radio-{{question.question_id}}[]"/>
          }
          <span class="custom-input__indi"></span>
          <span class="custom-input__label">{{option.answer}}</span>
        </label>
      }
      <br><br>
    </div>
  }

  @if (question.question_type_id==7 && question.options.indexOf('Yes') == -1 && !checkDisabledQuestions(question.question_id)) {
    <div class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
        <label class="custom-input custom-input--radio custom-input--pill">
          <input [hidden]="option.answer!=question.answer" type="radio" checked (click)="checkRadio(option.answer)" [attr.data-answer]="option.answer" name="radio-{{question.question_id}}[]"/>
          <input [hidden]="option.answer==question.answer" type="radio" (click)="checkRadio(option.answer)" [attr.data-answer]="option.answer" name="radio-{{question.question_id}}[]"/>
          <span class="custom-input__indi"></span>
          <span class="custom-input__label">{{option.answer}}</span>
        </label>
      }
      <br><br>
    </div>
  }

  @if (question.question_type_id==7 && checkDisabledQuestions(question.question_id)) {
    <div class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="input-group">
        <input type="text" disabled value="{{question.answer}}" placeholder="Placeholder" class="form-control">
        <div class="input-group-append">
          <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-html="true" data-placement="bottom" data-content="To change this answer you need to restart or contact us">
            <svg class="icon"><use xlink:href="#info"></use></svg>
          </a>
        </div>
      </div>
      <br><br>
    </div>
  }


  @if (question.question_type_id==19 && !checkDisabledQuestions(question.question_id)) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <select id="dropdown-{{question.index}}" class="ui-selectmenu">
        @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
          <option value="{{option.answer}}">
            {{option.answer}}
          </option>
        }
      </select>
      <br><br>
    </div>
  }

  @if (question.question_type_id==19 && checkDisabledQuestions(question.question_id)) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="input-group">
        <input type="text" disabled value="{{question.answer}}" placeholder="Placeholder" class="form-control">
        <div class="input-group-append">
          <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
            data-trigger="focus" data-html="true" data-placement="bottom"
            data-content="To change this answer you need to restart or contact us">
            <svg class="icon">
              <use xlink:href="#info"></use>
            </svg>
          </a>
        </div>
      </div>
      <br><br>
    </div>
  }

  @if (question.question_type_id==37) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="form-group form-group--lg">
        <div id="beneficiaries-accordion">
          <div class="card card--form">
            <a href="#allrisk" class="card-title" data-toggle="collapse" aria-expanded="true">
              <div class="card-title__text">
                <h4>{{getDescriptionIndex(item.description_1,2)}}</h4>
              </div>
              <div class="card-title__caret">
                <svg class="icon"><use xlink:href="#dropdown"></use></svg>
              </div>
            </a>
            <div class="card-body collapse show" id="allrisk" data-parent="#beneficiaries-accordion">
              <div class="card__content">
                <div class="form-group form-group--sm ui-front">
                  <label for="select-7">Category</label>
                  <select class="ui-selectmenu" id="category">
                    @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
                      <option (click)="checkAllrisk()" [selected]="option.answer==getDescriptionIndex(item.description_1,0)?'true':''" value="{{option.answer}}">
                        {{option.answer}}
                      </option>
                    }
                  </select>
                </div>
                <div class="form-group form-group--sm">
                  <label>Description</label>
                  <input type="text" id="description" (blur)="checkAllrisk();" value="{{getDescriptionIndex(item.description_1,1)}}" class="form-control">
                </div>
                <div class="form-group form-group--sm">
                  <label>Amount</label>
                  <input type="text" id="amount" (blur)="checkAllrisk();" value="{{accounting_.formatMoney(item.benefit_value)}}" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <!-- /card -->
        </div>
      </div>
      <br><br>
    </div>
  }

  @if (question.question_type_id==39 && checkDisabledQuestions(question.question_id)) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="input-group">
        <input type="text" disabled value="{{question.answer}}" placeholder="Placeholder" class="form-control">
        <div class="input-group-append">
          <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
            data-trigger="focus" data-html="true" data-placement="bottom"
            data-content="To change this answer you need to restart or contact us">
            <svg class="icon">
              <use xlink:href="#info"></use>
            </svg>
          </a>
        </div>
      </div>
      <br><br>
    </div>
  }

  @if (question.question_type_id==39 && !checkDisabledQuestions(question.question_id)) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="custom-number">
        @for (option of getButtonOptions(); track trackByFn(i, option); let i = $index) {
          <label class="custom-number__number">
            @if (option.answer==question.answer) {
              <input type="radio" (click)="checkRadio(option.answer)" checked name="numbers-{{question.question_id}}[]">
            }
            @if (option.answer!=question.answer) {
              <input type="radio" [disabled]="option.active==0" (click)="checkRadio(option.answer)" name="numbers-{{question.question_id}}[]">
            }
            <span class="custom-number__label">{{option.answer}}</span>
          </label>
        }
      </div>
      <br><br>
    </div>
  }

  @if (question.question_type_id==49 && checkDisabledQuestions(question.question_id)) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      <div class="input-group">
        <input type="text" disabled value="{{question.answer}}" placeholder="Placeholder" class="form-control">
        <div class="input-group-append">
          <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
            data-trigger="focus" data-html="true" data-placement="bottom"
            data-content="To change this answer you need to restart or contact us">
            <svg class="icon">
              <use xlink:href="#info"></use>
            </svg>
          </a>
        </div>
      </div>
      <br><br>
    </div>
  }
  @if (question.question_type_id==49 && !checkDisabledQuestions(question.question_id)) {
    <div
      class="form-group form-group--lg question question-{{question.group_type}}">
      <label>{{question.email_version}}</label>
      @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
        <label class="custom-input custom-input--checkbox custom-input--pill">
          @if (option.answer=='None of the above') {
            <input type="checkbox" data-type="exclusive" class="multiselect" value="{{option.answer}}" (click)="checkMultiSelect()" name="checkbox-{{option.cent_aq_answer_id}}"/>
          }
          @if (question.answer.indexOf(option.answer)>=0 && option.answer!='None of the above') {
            <input type="checkbox" checked class="multiselect" value="{{option.answer}}" (click)="checkMultiSelect()" name="checkbox-{{option.cent_aq_answer_id}}"/>
          }
          @if (question.answer.indexOf(option.answer)==-1 && option.answer!='None of the above') {
            <input type="checkbox" class="multiselect" value="{{option.answer}}"  (click)="checkMultiSelect()" name="checkbox-{{option.cent_aq_answer_id}}"/>
          }
          <span class="custom-input__indi"></span>
          <span class="custom-input__label">{{option.answer}}</span>
        </label>
      }
      <br><br>
    </div>
  }
  <!-- <div *ngIf="question.question_type_id==78 && item?.benefit_value" class="form-group form-group--sm question" id="insured">
  <label>Adjusted Sum Insured</label>
  <app-slider
    [question]="question"
    [item]="item"
    [sliderStep]="100"
    [sliderMin]="question?.val_min"
    [sliderMax]="question?.val_max"
    [sliderInit]="item?.benefit_value"
    [type]="'suminsured'"
    (slideUpdate)=saveSliderValue($event)>
  </app-slider>
  <br><br>
</div>
<div *ngIf="question.question_type_id==79 || question.question_type_id==37" class="form-group form-group--lg question question-{{question.group_type}}">
  <label>{{question.email_version}}</label>
  <app-slider
    [question]="question"
    [item]="item"
    [sliderStep]="10"
    [sliderMin]="question?.excess_min"
    [sliderMax]="question?.excess_max"
    [sliderInit]="question?.answer"
    (slideUpdate)=saveSliderValue($event)>
  </app-slider>
  <br><br>
</div> -->
@if (question.question_type_id==78) {
  <div class="form-group form-group--lg question question-{{question.group_type}}">
    <label>{{question.email_version}}</label>
    <app-slider
      [question]="question"
      [item]="item"
      [sliderStep]="10"
      [sliderMin]="question?.val_min"
      [sliderMax]="question?.val_max"
      [sliderInit]="question?.answer"
      [type]="''"
      (slideUpdate)=saveSliderValue($event)>
    </app-slider>
    <br><br>
  </div>
}








